export const API_URL = import.meta.env.DEV ? `http://${window.location.hostname}:3006` : window.location.origin;
